import React, {useState, useEffect} from "react";
import { GetCategoriesData} from "../../../lib/data";
import { getCategoryById } from "../../../lib/apiCalls";
import { useParams } from "react-router-dom";
import EditCategoiresUi from "../../../ui/categoriesUi/EditCategoriesUi";
import i18n from "../../../lib/i18n";

export default function EditCategoires () {

    const [categoriesData, setCategoriesData] = useState([]);
    const [categoryByIdData, setCategoryByIdData] = useState({});
    const {categoryId} = useParams();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const params = [ {"status": "main"} ];
        const categoryData = await GetCategoriesData(1, params);
        const categoryByIdData = await getCategoryById(categoryId);
        setCategoriesData([]);
        setCategoryByIdData({});
        setCategoryByIdData(categoryByIdData.data.data);
        categoryData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param}, {"status": "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesData([]);
            categoriesDataFilter.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.category")}</h1>
                <EditCategoiresUi search={search} categoryByIdData={categoryByIdData} categoriesData={categoriesData} />
            </div>
        </div>
    );
};